import { render, staticRenderFns } from "./rworangtua.vue?vue&type=template&id=0a40a3e0"
import script from "./rworangtua.vue?vue&type=script&lang=js"
export * from "./rworangtua.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports